import { usePermissionCheck } from '@percent/partner-dashboard/common/hooks/useAllow/usePermissionCheck'
import { POSTHOG_FEATURE_FLAGS, useAuthState, usePostHogFeatureFlag } from '@percent/partner-dashboard/common/hooks'
import { selectScopes } from '@percent/partner-dashboard/context/auth'
import { canViewReports } from './reportsConfig'

// Single gate for the insights reports surface, shared by the nav and route guards.
export const useCanViewInsightsReports = (): boolean => {
  const insightsReportsFeatureFlag = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.PD_INSIGHTS_REPORTS)
  const { partner } = useAuthState()
  const { userCan } = usePermissionCheck()

  return canViewReports({ insightsReportsFeatureFlag, scopes: selectScopes(partner?.scopes), userCan })
}
